<template>
  <div class="d-flex flex-column col-3 justify-content-center">
    <div class="d-flex flex-column align-items-center">
      <span class="position-relative d-block">
        <span class="battle-account_avatar-border d-block">
          <LinkAccount
            :id="player && player.login && player.login"
            :type="(player && player.type && player.type) || 'profile'"
          >
            <Avatar
              :type="player && player.type && player.type"
              :img-url="
                (player && player.avatar && player.avatar) ||
                  (player && player.logo && player.logo)
              "
              :size="64"
              class="players-item-avatar"
            />
          </LinkAccount>
        </span>
      </span>
      <TextBlock
        :text="player && player.name && player.name"
        class="text-truncate mw-100 mt-3"
      />
      <TextBlock
        :text="description"
        :size="0.8"
        variant="secondary"
        class="mt-3"
      />
    </div>
  </div>
</template>

<script>
import { translate } from '@/mixins/translate';
import Avatar from '@/components/images/Avatar';
import TextBlock from '@/components/atoms/TextBlock';
import LinkAccount from '@/components/links/Account';

export default {
  name: 'PlayerCard',
  components: {
    Avatar,
    TextBlock,
    LinkAccount,
  },
  mixins: [translate('_web_battle-results-tab-card')],
  props: {
    player: {
      type: Object,
      default: () => {},
    },
    description: {
      type: String,
      default: '',
    },
  },
};
</script>
